import { render, staticRenderFns } from "./myScene.vue?vue&type=template&id=67249a88&"
import script from "./myScene.vue?vue&type=script&lang=js&"
export * from "./myScene.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "myScene.vue"
export default component.exports